<p-toast />
<p-card>
    <h3> Campaign Report Export</h3>
    <rc-generic-button 
    label="Download Report"
    id="button-download"
    (click)="onDownload()"
    [classes]="['my-1 ml-1']" />

</p-card>